
exports.pbkdf2 = require('./lib/async')

exports.pbkdf2Sync = require('./lib/sync')



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/pbkdf2/browser.js
// module id = 649
// module chunks = 2